import { render, staticRenderFns } from "./yjsTab.vue?vue&type=template&id=37253cc4&scoped=true&"
import script from "./yjsTab.vue?vue&type=script&lang=js&"
export * from "./yjsTab.vue?vue&type=script&lang=js&"
import style0 from "./yjsTab.vue?vue&type=style&index=0&id=37253cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37253cc4",
  null
  
)

export default component.exports